import { AfterViewInit, Component, HostBinding, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { EnumQrBatchStatus } from '../../enum/qr-product.enum';
import { MatChipListbox, MatChipListboxChange } from '@angular/material/chips';
import { UtilitiesService } from '@services/utilities.service';

@Component({
  selector: 'app-filter-list-qr-product',
  templateUrl: './filter-list-qr-product.component.html',
  styleUrls: ['./filter-list-qr-product.component.scss'],
})
export class FilterListQrProductComponent implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('class') class = 'd-flex w-100 justify-content-between';

  @Input() finishLoadingSubject = new BehaviorSubject(true);
  @Input() searchInputValue: string = '';
  @Input() filterInputActivated = false;
  @Input() showAddBatch = true;

  filterInputOpened = false;
  filterPills: string[] = [];

  filterForm: FormGroup;

  @ViewChild('filterPillsBox') filterPillsBox: MatChipListbox;

  get batchStatusControl() {
    return <FormControl>this.filterForm.get('status');
  }

  constructor(private formBuilder: FormBuilder, private router: Router, private activatedRoute: ActivatedRoute, private utilitiesService: UtilitiesService) {
    this.filterForm = this.formBuilder.group({
      status: new FormControl(),
    });
  }

  ngOnInit() {
    this.initFilter();
  }

  initFilter() {
    const _keys = Object.keys(EnumQrBatchStatus);
    return (this.filterPills = _keys.map((_item) => Object(EnumQrBatchStatus)[_item]));
  }

  initFilterPillsBox() {
    const snapshot = this.activatedRoute.snapshot;
    const { queryParams } = snapshot;

    const queryParamIsEmpty = !Object.keys(queryParams).length;
    if (queryParamIsEmpty) return;

    const _arrayStatus = 'status' in queryParams ? queryParams.status.split(',') : [];
    if (!_arrayStatus.length) return;

    const _selectedStatus: string[] = [];
    _arrayStatus.forEach((_status: string) => {
      const value = this.utilitiesService.mapKeyToString(EnumQrBatchStatus, _status);
      _selectedStatus.push(value);
    });

    this.filterPillsBox.value = _selectedStatus;
  }

  handleSubmitFilter() {
    if (!this.batchStatusControl.value) {
      return;
    }

    this.filterInputOpened = false;

    const snapshot = this.activatedRoute.snapshot;
    const dataParam = { ...snapshot.queryParams };
    delete dataParam.page;

    this.router.navigate([], { queryParams: { ...dataParam, ...this.filterForm.value } }).then(() => null);
  }

  handleSearchAction(e: string) {
    const snapshot = this.activatedRoute.snapshot;
    const dataParam = { ...snapshot.queryParams };

    if (e) {
      delete dataParam.page;
      return this.router.navigate([], {
        queryParams: {
          ...dataParam,
          search: '' || e,
        },
      });
    } else {
      delete dataParam.search;
      return this.router.navigate([], { queryParams: dataParam });
    }
  }

  handleResetFilter() {
    this.filterInputOpened = false;
    this.resetFilterForm();

    const snapshot = this.activatedRoute.snapshot;
    const dataParam = { ...snapshot.queryParams };
    for (const _k in dataParam) {
      if (_k !== 'search') {
        delete dataParam[_k];
      }
    }

    return this.router.navigate([], { queryParams: dataParam });
  }

  handleBatchStatusChange(e: MatChipListboxChange) {
    const _selectedKey: string[] = [];
    e.value.forEach((item: string) => _selectedKey.push(this.utilitiesService.getEnumKeyByValue(EnumQrBatchStatus, item)));
    this.batchStatusControl.patchValue(_selectedKey.join());
  }

  resetFilterForm() {
    this.batchStatusControl.patchValue('');
    this.resetFilterPillsBox();
  }

  ngAfterViewInit() {
    this.initFilterPillsBox();
  }

  handleActionAddBatch = () => this.router.navigate(['/products/generate-qr-batch']);

  toggleOpenFilter = () => (this.filterInputOpened = !this.filterInputOpened);

  resetFilterPillsBox = () => (this.filterPillsBox.value = []);

  ngOnDestroy() {}

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
